/**
 * Platform detection utilities
 */

/**
 * Detect if device is Android mobile
 */
export function isAndroidMobile(): boolean {
  return /Android/.test(navigator.userAgent);
}

/**
 * Detect if device is Apple mobile (iOS)
 */
export function isAppleMobile(): boolean {
  return /iPhone|iPad|iPod/.test(navigator.userAgent);
}

/**
 * Detect if device is mobile (iOS or Android)
 */
export function isMobile(): boolean {
  return isAndroidMobile() || isAppleMobile();
}

/**
 * Detect if device is desktop
 */
export function isDesktop(): boolean {
  return !isMobile();
}

/**
 * Detect the in-app browsers of Instagram, Facebook and TikTok, which can't save downloaded files
 */
export function isInAppBrowser(): boolean {
  return /Instagram|FBAN|FBAV|BytedanceWebview|musical_ly/.test(navigator.userAgent);
}
